<template>
  <svg class="brand-spark" viewBox="0 0 16 16" aria-hidden="true">
    <path fill="currentColor" d="M8 0.4 9.05 6.2 15.6 8 9.05 9.8 8 15.6 6.95 9.8 0.4 8 6.95 6.2Z" />
  </svg>
</template>

<style scoped>
.brand-spark {
  display: block;
  flex-shrink: 0;
  height: 14px;
  width: 14px;
}
</style>
